document.addEventListener('teeinblue-event-after-cart-added', function() {
  var request = new XMLHttpRequest();
  
  request.open('GET', '/cart.js', true);

  request.onload = function() {
        if (this.status >= 200 && this.status < 400) {
          var data = JSON.parse(this.response);
          
          const drawer = document.querySelector('cart-notification');
          if (drawer) {
                fetch(window.location.pathname + "?sections=cart-notification-product,cart-notification-button,cart-icon-bubble")
                .then(res => res.json())
                .then(res => drawer.renderContents({key: data.items[0].key,sections: res}));
          }
        }
  };

  request.send();
});